import React from "react";

let CombinedData = props => (
  <svg width={24} height={24} viewBox="0 0 10 15" {...props}>
    <path d="M6.036 6.445H8.96c.229-.012.36.006.484.16.16.199.097.351-.055.537l-5.878 7.116c-.18.185-.29.258-.53.163-.26-.102-.273-.239-.226-.518l1.21-4.98H.968c-.216.006-.402-.054-.474-.281-.055-.178.011-.303.123-.42L6.502 1.1c.158-.146.263-.208.47-.153.278.073.31.232.278.507l-1.214 4.99z" />
  </svg>
);

export default CombinedData;
